import React from 'react';
import { Chip, Radio } from '@mui/material';
import { GridColDef } from '@mui/x-data-grid';
import { FGrid, FGridMoneyCell } from '../grid';
import { IExecutiveScenarioCandidate } from './executiveReview.models';

type Props = {
  rows: IExecutiveScenarioCandidate[];
  selectedScenarioId?: number;
  loading?: boolean;
  editable: boolean;
  onSelectScenario: (row: IExecutiveScenarioCandidate) => void;
};

class ScenarioComparisonGrid extends React.PureComponent<Props> {
  columns: GridColDef[] = [
    {
      field: 'select',
      headerName: '',
      width: 64,
      sortable: false,
      renderCell: (p) => (
        <Radio
          checked={
            Number(this.props.selectedScenarioId || 0) ===
            Number(p.row.scenarioid)
          }
          disabled={!this.props.editable || !p.row.eligible}
          onChange={() => this.props.onSelectScenario(p.row)}
        />
      ),
    },
    { field: 'scenariocode', headerName: 'Scenario', width: 140 },
    { field: 'scenarioname', headerName: 'Name', flex: 1, minWidth: 220 },
    {
      field: 'partialresult',
      headerName: 'Trade Surplus',
      width: 155,
      renderCell: FGridMoneyCell,
    },
    {
      field: 'economiccapacity',
      headerName: 'Economic Capacity',
      width: 170,
      renderCell: FGridMoneyCell,
    },
    {
      field: 'availablebudget',
      headerName: 'Available Budget',
      width: 165,
      renderCell: FGridMoneyCell,
    },
    {
      field: 'objectivegap',
      headerName: 'Objective Gap',
      width: 135,
      type: 'number',
    },
    {
      field: 'sensitivityscore',
      headerName: 'Sensitivity',
      width: 125,
      type: 'number',
    },
    {
      field: 'stresscode',
      headerName: 'Stress',
      width: 110,
      renderCell: (p) => (
        <Chip
          size="small"
          label={p.value || 'NORMAL'}
          color={
            p.value === 'HIGH'
              ? 'error'
              : p.value === 'MEDIUM'
                ? 'warning'
                : 'success'
          }
        />
      ),
    },
    { field: 'blockingcount', headerName: 'Blocks', width: 90, type: 'number' },
    {
      field: 'eligible',
      headerName: 'Eligible',
      width: 105,
      renderCell: (p) => (
        <Chip
          size="small"
          label={p.value ? 'Yes' : 'No'}
          color={p.value ? 'success' : 'default'}
        />
      ),
    },
  ];
  render() {
    return (
      <FGrid
        title="Scenario Comparison"
        subtitle="Select exactly one eligible scenario from the frozen Simulation submission."
        rows={this.props.rows || []}
        columns={this.columns}
        loading={this.props.loading}
        height={520}
        showQuickFilter
        getRowId={(r: any) => r.scenarioid || r.id}
        onRowClick={(p: any) =>
          p.row.eligible &&
          this.props.editable &&
          this.props.onSelectScenario(p.row)
        }
        pageSizeOptions={[10, 25, 50]}
      />
    );
  }
}
export default ScenarioComparisonGrid;
